import React, { useCallback, useContext, useMemo } from 'react';
import { Stack, ChoiceGroup, MessageBar, MessageBarType } from '@fluentui/react';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getAdRotationStyles = (components, theme) => ({
  AdRotationMessageBar: {
    backgroundColor: theme.palette.themeLighterAlt,
  },
});

const AdRotation = ({
  updateValidation,
  validationProps,
}) => {
  const {
    data,
  } = validationProps || {};
  // Must have an initial value or the Fluent UI will take the choice group as uncontrolled
  const { AdRotation: adRotation = 'OptimizeForClicks' } = data || {};
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getAdRotationStyles);

  const adRotationOptions = useMemo(() => [{
    key: 'OptimizeForClicks',
    text: i18n.getString(_TL_('Optimize - prioritize ads that perform well')),
  }, {
    key: 'RotateAdsEvenly',
    text: i18n.getString(_TL_('Rotate ads more evenly - include all ads, even those with a lower CTR')),
  }], [i18n]);

  const onChange = useCallback((ev, option) => {
    updateValidation([], {
      AdRotation: option.key,
    });
  }, [updateValidation]);

  return (<Stack className="ad-rotation">
    <div>{i18n.getString(_TL_('Which ads do you want to show?'))}</div>
    <ChoiceGroup
      options={adRotationOptions}
      onChange={onChange}
      selectedKey={adRotation}
    />
    <MessageBar
      messageBarType={MessageBarType.info}
      className={classes.AdRotationMessageBar}
    >
      {i18n.getString(_TL_('This ad rotation setting will be ignored if you use an automated bidding bid strategy, as automated bidding prioritizes better-performing ads.'))}
    </MessageBar>
          </Stack>);
};

export const ValidatedAdRotation = withCustomValidation(AdRotation);
